import React, { useRef, useEffect } from "react";
import Chart from "chart.js/auto";

const LineChart = ({
  type,
  data,
  labels,
  legend,
  titl,
  XAxisLabel,
  YAxisLabel,
  customKey,
  chartRef,
  dollar = true,
  valuefontsize = 8,
}) => {
  if (!data || data.length === 0) {
    return <div className="Nodata">No data available</div>;
  }

  const chartInstance = useRef(null);
  const title = "Year - " + titl;
  const colors = [
    "#ebcaae",
    "#f68a78",
    "#f3e573",
    "#ebb556",
    "#79d4c5",
    "#a7e7db",
    "#a7cae7",
    "#50d790",
    "#caee9c",
    "#d1d65d",
    "#fbd9bb",
    "#e3b286",
    "#d17b75",
  ];
  const colorcode = [
    "rgba(232, 193, 192, 0.2)",
    "rgba(244, 117, 192, 0.2)",
    "rgba(241, 225, 192, 0.2)",
    "rgba(232, 168, 192, 0.2)",
    "rgba(97, 205, 192, 0.2)",
  ];
  const dataset = {
    labels: labels,
    datasets: legend?.map((dataset, index) => ({
      label: legend[index],
      data: data?.map((v) => v[index]),
      backgroundColor: colorcode[index],
      fill: customKey === "RDD" ? false : true,
      borderColor: colorcode[index], // Color for the line
      borderWidth: 4,
      pointBackgroundColor: colors[index], // Color for data points
      pointBorderColor: colors[index],
      pointBorderWidth: 2,
      pointRadius: 5,
      pointHoverBackgroundColor: colorcode[index],
      pointHoverBorderColor: colorcode[index],
      pointHoverBorderWidth: 2,
    })),
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    aspectRatio: 1.8,
    plugins: {
      title: {
        display: false,
        text: title,
        font: {
          family: "optimare",
          size: 12,
          weight: "bold",
          lineHeight: 1.2,
        },
      },
      legend: {
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            family: "optimare",
            size: 12,
            style: "normal",
            weight: "bold",
            lineHeight: 1.2,
          },
        },
        onHover: (event, item, legend) => {
          legend.chart.data.datasets[item.datasetIndex].pointStyle = "circle";
          legend.chart.update();
        },
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return "$" + tooltipItem.formattedValue;
          },
        },
      },
      datalabels: {
        display: true,
        color: "grey",
        // anchor: "center",
        // align: "center",
        font: {
          // weight: "bold",
          size: valuefontsize,
          family: "optimare",
        },

        formatter: function (value) {
          return value == 0
            ? ""
            : dollar
            ? `$${(value / 1000).toFixed(1)}K`
            : value;
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: XAxisLabel,
          color: "#9d7a4d",
          font: {
            family: "optimare",
            weight: "bold",
            size: 11,
            lineHeight: 1.2,
          },
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: YAxisLabel,
          color: "#9d7a4d",
          font: {
            family: "optimare",
            weight: "bold",
            size: 11,
            lineHeight: 1.2,
          },
        },
      },
    },
  };

  useEffect(() => {
    if (chartRef && chartRef.current) {
      const ctx = chartRef.current.getContext("2d");
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
      chartInstance.current = new Chart(ctx, {
        type: type,
        data: dataset,
        options: options,
      });
    }

    // Cleanup on unmount
    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, [data, labels, legend, titl]);

  return <canvas ref={chartRef} />;
};

export default LineChart;
